import React from "react"
import { view } from "react-easy-state"
import { isMobile } from "react-device-detect"
import { message } from "antd"

import ContentLoader from "components/common/ContentLoader"

import globalStore from "store"

import QuestionnairesService from "services/students/questionnaires.service"
import AskDoubt from "components/pages/students/AskDoubt"

class QuestionnairesStartPage extends React.Component {
  async fetchData() {
    const { questionType, match } = this.props
    const { chapterId, questionnaireId } = match.params

    const pageState = globalStore.ui.students.questionnaires.start
    await QuestionnairesService.start({
      pageState,
      chapterId,
      questionnaireId,
      questionType,
    })
  }

  async componentDidMount() {
    await this.fetchData()
  }

  renderPageContent() {
    const { chapterId, questionnaireId } = this.props.match.params
    const pageState = globalStore.ui.students.questionnaires.start
    const {
      question,
      questionnaire_attempt,
      questionErrors,
      questionnaireAttemptedErrors,
      API_QUESTIONNAIRES_START_STATUS,
    } = pageState

    if (!API_QUESTIONNAIRES_START_STATUS) return <ContentLoader />
    if (API_QUESTIONNAIRES_START_STATUS === "pending") return <ContentLoader />
    if (API_QUESTIONNAIRES_START_STATUS === "rejected") return <ContentLoader />

    if (questionErrors || questionnaireAttemptedErrors) {
      message.detroy()
      message.error(questionErrors || questionnaireAttemptedErrors)
      this.props.history.push(`chapters/${chapterId}`)
      return
    }

    if (questionErrors) {
      message.detroy()
      message.error(questionErrors)
      this.props.history.push(`chapters/${chapterId}`)
      return
    }

    if (!question) {
      let msg = "No question found"
      const { questionType } = this.props
      const {
        attempted_subjective_questions_count,
        attempted_objective_questions_count,
        total_objective_questions_count,
        total_subjective_questions_count,
      } = questionnaire_attempt

      if (
        attempted_objective_questions_count ===
          total_objective_questions_count ||
        attempted_subjective_questions_count ===
          total_subjective_questions_count
      ) {
        msg = `You have attempted all ${questionType} questions.`
      }

      message.destroy()
      message.warning(msg)
      this.props.history.replace(`/chapters/${chapterId}`)
      return false
    }

    delete pageState.API_QUESTIONNAIRES_START_STATUS
    delete pageState.question
    this.props.history.replace(
      `/chapters/${chapterId}/questionnaires/${questionnaireId}/questions/${question.id}`
    )
    return
  }

  componentWillUnmount() {
    globalStore.ui.students.questionnaires.start = {}
  }

  render() {
    return (
      <div className={`page course-page ${isMobile ? "mobile" : ""}`}>
        {this.renderPageContent()}
        <AskDoubt />
      </div>
    )
  }
}

export default view(QuestionnairesStartPage)
